<template>
    <div class="card">
        <div class="table-header">
            <h5 class="p-m-0">
                Характеристики товарів
            </h5>
            <a :href="route('api.catalog.product.characteristic.export')">
                <Button icon="pi pi-external-link" label="Скачати в Excel" />
            </a>
        </div>
        <DataTable
            :value="data"
            v-model:selection="selectedCharacteristics"
            v-model:filters="filterParams.filters"
            filterDisplay="row"
            paginator
            lazy
            :rows="filterParams.perPage"
            :rowsPerPageOptions="[50, 100, 200]"
            :total-records="total"
            :loading="loading"
            @page="onPage($event)"
            @filter="getData()"
            class="customTable"
            style="overflow: auto;"
            paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            current-page-report-template="Всього {totalRecords}"
            @row-select-all="onSelectAllChange"
            @row-select="onRowSelect"
            @row-unselect="onRowUnselect"
        >
            <Column selectionMode="multiple" :class="{'select-all-selected': selectAll}" headerStyle="width: 3rem"></Column>
            <Column field="name" header="Найменування" headerStyle="min-width: 400px">
                <template #body="slotProps">
                    <InputText class="price_input" v-model="slotProps.data.name" />
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.name.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="unit" header="Од. виміру">
                <template #body="slotProps">
                    <InputText style="width: 100px" class="price_input" v-model="slotProps.data.unit" />
                </template>
                <template #filter>
                    <InputText style="width: 100px" v-model="filterParams.filters.unit.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="unit" header="Позиція">
                <template #body="slotProps">
                    <InputText style="width: 100px" class="price_input" v-model="slotProps.data.position" />
                </template>
            </Column>
            <Column field="type" header="Тип"  headerStyle="min-width: 100px">
                <template #body="slotProps">
                    <Dropdown style="width: 100px" v-model="slotProps.data.type" :options="types" optionLabel="name" optionValue="value" placeholder="Оберіть значення" class="price_input" />
                </template>
                <template #filter>
                    <Dropdown style="width: 100px" v-model="filterParams.filters.type.value" :options="types" @change="getData()" optionLabel="name" optionValue="value" placeholder="Оберіть значення" />
                </template>
            </Column>
            <Column field="group" header="Група" headerStyle="min-width: 150px">
                <template #body="slotProps">
                    <InputText class="price_input" v-model="slotProps.data.group" style="width: 150px" />
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.group.value" type="text" @input="getData()" placeholder="Пошук" style="width: 150px" />
                </template>
            </Column>
            <Column field="is_active" header="Публікація">
                <template #body="slotProps">
                    <label class="check-text">
                        <input type='checkbox' v-model="slotProps.data.is_active"/>
                        <svg v-if="slotProps.data.is_active" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.00033 0C4.66699 0 1.82033 2.07333 0.666992 5C1.82033 7.92667 4.66699 10 8.00033 10C11.3337 10 14.1803 7.92667 15.3337 5C14.1803 2.07333 11.3337 0 8.00033 0ZM8.00033 8.33333C6.16033 8.33333 4.66699 6.84 4.66699 5C4.66699 3.16 6.16033 1.66667 8.00033 1.66667C9.84033 1.66667 11.3337 3.16 11.3337 5C11.3337 6.84 9.84033 8.33333 8.00033 8.33333ZM8.00033 3C6.89366 3 6.00033 3.89333 6.00033 5C6.00033 6.10667 6.89366 7 8.00033 7C9.10699 7 10.0003 6.10667 10.0003 5C10.0003 3.89333 9.10699 3 8.00033 3Z" fill="#356EEF"/>
                        </svg>

                        <svg v-else width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.00033 0.000244141C4.66699 0.000244141 1.82033 2.07358 0.666992 5.00024C1.82033 7.92691 4.66699 10.0002 8.00033 10.0002C11.3337 10.0002 14.1803 7.92691 15.3337 5.00024C14.1803 2.07358 11.3337 0.000244141 8.00033 0.000244141ZM8.00033 8.33358C6.16033 8.33358 4.66699 6.84024 4.66699 5.00024C4.66699 3.16024 6.16033 1.66691 8.00033 1.66691C9.84033 1.66691 11.3337 3.16024 11.3337 5.00024C11.3337 6.84024 9.84033 8.33358 8.00033 8.33358ZM8.00033 3.00024C6.89366 3.00024 6.00033 3.89358 6.00033 5.00024C6.00033 6.10691 6.89366 7.00024 8.00033 7.00024C9.10699 7.00024 10.0003 6.10691 10.0003 5.00024C10.0003 3.89358 9.10699 3.00024 8.00033 3.00024Z" fill="#AFBBC7"/>
                        </svg>
                    </label>
                </template>
                <template #filter>
                    <Dropdown v-model="filterParams.filters.is_active.value" :options="viewVariants" @change="getData()" optionLabel="name" optionValue="value" placeholder="Всі" />
                </template>
            </Column>
            <Column field="is_filter" header="Для фільтрування">
                <template #body="slotProps">
                    <label class="check-text">
                        <input type='checkbox' v-model="slotProps.data.is_filter"/>
                        <svg v-if="slotProps.data.is_filter" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.00033 0C4.66699 0 1.82033 2.07333 0.666992 5C1.82033 7.92667 4.66699 10 8.00033 10C11.3337 10 14.1803 7.92667 15.3337 5C14.1803 2.07333 11.3337 0 8.00033 0ZM8.00033 8.33333C6.16033 8.33333 4.66699 6.84 4.66699 5C4.66699 3.16 6.16033 1.66667 8.00033 1.66667C9.84033 1.66667 11.3337 3.16 11.3337 5C11.3337 6.84 9.84033 8.33333 8.00033 8.33333ZM8.00033 3C6.89366 3 6.00033 3.89333 6.00033 5C6.00033 6.10667 6.89366 7 8.00033 7C9.10699 7 10.0003 6.10667 10.0003 5C10.0003 3.89333 9.10699 3 8.00033 3Z" fill="#356EEF"/>
                        </svg>

                        <svg v-else width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.00033 0.000244141C4.66699 0.000244141 1.82033 2.07358 0.666992 5.00024C1.82033 7.92691 4.66699 10.0002 8.00033 10.0002C11.3337 10.0002 14.1803 7.92691 15.3337 5.00024C14.1803 2.07358 11.3337 0.000244141 8.00033 0.000244141ZM8.00033 8.33358C6.16033 8.33358 4.66699 6.84024 4.66699 5.00024C4.66699 3.16024 6.16033 1.66691 8.00033 1.66691C9.84033 1.66691 11.3337 3.16024 11.3337 5.00024C11.3337 6.84024 9.84033 8.33358 8.00033 8.33358ZM8.00033 3.00024C6.89366 3.00024 6.00033 3.89358 6.00033 5.00024C6.00033 6.10691 6.89366 7.00024 8.00033 7.00024C9.10699 7.00024 10.0003 6.10691 10.0003 5.00024C10.0003 3.89358 9.10699 3.00024 8.00033 3.00024Z" fill="#AFBBC7"/>
                        </svg>
                    </label>

                    <label class="check-text" style="padding-left: 10px;">
                        <a href="javascript:void(0)" @click="getItemData(slotProps.data.id)">Категорії: {{ slotProps.data.categories_count }}</a>
                    </label>
                </template>
                <template #filter>
                    <Dropdown v-model="filterParams.filters.is_filter.value" :options="viewVariants" @change="getData()" optionLabel="name" optionValue="value" placeholder="Всі" />
                </template>
            </Column>
            <Column field="catalogсharacteristic_count" header="Кількість SKU">
                <template #body="slotProps">
                    <a href="javascript:void(0)" @click.stop="downloadExcel(slotProps.data)">{{ slotProps.data.catalogсharacteristic_count }}</a>
                </template>
            </Column>
            <Column field="" header="">
                <template #body="slotProps">
                    <a href="#" @click.prevent="() => {selectedCharacteristics=[]; selectedCharacteristics.push(slotProps.data); deleteCharacteristics()}">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.26671 9.66683L0.333374 8.7335L4.06671 5.00016L0.333374 1.26683L1.26671 0.333496L5.00004 4.06683L8.73337 0.333496L9.66671 1.26683L5.93337 5.00016L9.66671 8.7335L8.73337 9.66683L5.00004 5.9335L1.26671 9.66683Z" fill="#B70D09"/>
                        </svg>
                    </a>
                </template>
            </Column>
        </DataTable>

        <div class="bottom_btns">
            <a href="javascript:void(0)" class="add_file_btn" @click="save()">Зберегти</a>

            <a href="javascript:void(0)" class="add_file_btn main" v-if="!library_sync" @click="makeSync()">Запустити синхронізацію</a>
            <a href="javascript:void(0)" class="add_file_btn main" v-else>Йде процес синхронізації..</a>


            <a href="javascript:void(0)" class="add_file_btn main" @click="isAddCharacteristics=true">Додати нову</a>
            <a href="javascript:void(0)" class="add_file_btn main" v-if="selectedCharacteristics.length" @click="deleteCharacteristics()">Видалити</a>
            <a href="javascript:void(0)" class="add_file_btn main disabled" v-else>Видалити</a>
        </div>

        <Dialog v-model:visible="isAddCharacteristics" id="characteristics-table" header="Створення нової характеристики" :style="{ width: '500px' }" modal :contentStyle="{ height: '250px' }">
            <div class="modal_main_content_container">
                <InputText class="price_input" placeholder="Назва" v-model="newCharacteristic.name" />
                <InputText class="price_input" placeholder="Од. виміру" v-model="newCharacteristic.unit" />
                <Dropdown v-model="newCharacteristic.type" :options="types" optionLabel="name" optionValue="value" placeholder="Тип" class="price_input" />
                <InputText class="price_input" placeholder="Група" v-model="newCharacteristic.group" />
            </div>
            <template #footer>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="addCharacteristics()">Додати</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="isAddCharacteristics=false">Відмінити</a>
                </div>
            </template>
        </Dialog>

        <Dialog v-model:visible="isSelectCategory" id="characteristics-category-table" :header="'Категорії (' + selectedCategoriesCount + ')'" :style="{ width: '900px' }" modal :contentStyle="{ height: '600px' }">
            <!-- <div class="selected_cats">
                <b>Обрані категорії:</b>
                <template v-for="(item, i) of Object.values(selectedCategories)" :key="i">
                    <p v-if="i <= 3">
                        {{ item.name }}
                    </p>
                </template>
                <b v-if="Object.keys(selectedCategories).length > 4">
                    (+{{ Object.keys(selectedCategories).length - 4 }})
                </b>
            </div> -->
            <div class="modal_main_content_container">
                <Tree v-model:selectionKeys="selectedCategories" :value="categories" selectionMode="checkbox" class="catalog_tree"></Tree>
            </div>
            <template #footer>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="updateCategories()">Зберегти</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="isSelectCategory=false">Відмінити</a>
                </div>
            </template>
        </Dialog>
    </div>
</template>

<script>
import axios from "axios";
import AppLayout from "@/Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import swal from 'sweetalert2';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Toast from 'primevue/toast';
import {FilterMatchMode} from "primevue/api";
import Tree from 'primevue/tree';

export default {
    props: {
        library_sync: Boolean
    },
    components: {
        DataTable,
        Column,
        InputText,
        swal,
        Dialog,
        Button,
        Dropdown,
        Toast,
        Tree,
    },
    layout: AppLayout,

    data() {
        return {
            data: [],
            total: 0,
            selectedCharacteristics: [],
            filterParams: {
                page: 1,
                perPage: 50,
                filters: {
                    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    unit: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    type: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    group: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    is_active: { value: null, matchMode: FilterMatchMode.CONTAINS },
                    is_filter: { value: null, matchMode: FilterMatchMode.CONTAINS },
                }
            },
            newCharacteristic: {
                name: null,
                type: 1,
                group: 'Без групи',
                is_active: 1,
                is_filter: false,
            },
            loading: false,
            selectAll: false,
            isAddCharacteristics: false,
            types: [
                {
                    value: 1,
                    name: 'Текстовий'
                },
                {
                    value: 2,
                    name: 'Числовий'
                },
                {
                    value: 3,
                    name: 'Булевий'
                }
            ],
            viewVariants: [
                {
                    value: null,
                    name: 'Всі'
                },
                {
                    value: true,
                    name: 'Активні'
                },
                {
                    value: false,
                    name: 'Приховані'
                },
            ],
            isSelectCategory: false,
            categories: [],
            selectedCategories: {},
            selectedItem: null,
        }
    },

    mounted() {
        this.getData();
    },

    computed: {
        selectedCategoriesCount() {
            let total = 0

            Object.values(this.selectedCategories).forEach((value, index) => {
                if (value.checked) {
                    total++
                }
            });
            
            return total
        }
    },

    methods: {
        downloadExcel(item) {
            if (item.catalogсharacteristic_count <= 0) {
                return false
            }
            
            new swal({
                title: 'Ви впевнені?',
                text: 'Буде вивантажено ' + item.catalogсharacteristic_count + ' товарів по характеристиці - ' + item.name,
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    return
                }

                axios.post(this.route('api.catalog.product.characteristic.library.export'), {
                    id: item.id,
                })
                .then((response) => {
                    var fileURL = response.data.data;
                        var fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', response.data.name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                }).catch((error) => {
                    alert(error);
                    window.scroll(0, 0);
                })
            });
        },
        save() {
            axios.post(this.route('api.catalog.product.characteristic.library.update'), {data: this.data}).then(result => {
                this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Характеристики успішно оновлено', life: 3000 });
                this.getData()
            });
        },
        makeSync() {
            axios.post(this.route('api.catalog.product.characteristic.library.sync'), {}).then(result => {
                this.$toast.add({ severity: 'success', summary: 'Успішно!', detail: 'Запущено процес синхронізації', life: 3000 });
                location.reload()
            });
        },
        updateCategories() {
            axios.post(this.route('api.catalog.product.characteristic.library.category.update'), {id: this.selectedItem, categories: this.selectedCategories}).then(result => {
                this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Характеристики успішно оновлено', life: 3000 });
                this.selectedCategories = {};
                this.selectedItem = null;
                this.isSelectCategory = false
                this.getData()
            });
        },
        addCharacteristics() {
            axios.post(this.route('api.catalog.product.characteristic.library.add'), this.newCharacteristic).then(result => {
                this.newCharacteristic = {
                    name: null,
                    type: 1,
                    group: 'Без групи',
                    is_active: 1,
                }

                this.isAddCharacteristics = false
                
                this.getData()
            });
        },
        getData() {
            this.loading = true
            axios.post(this.route('api.catalog.product.characteristic.get'), this.filterParams).then(result => {
                this.data = result.data.characteristics.data;
                this.total = result.data.characteristics.total;
                this.categories = result.data.categories;
                this.loading = false
            });
        },
        getItemData(id) {
            axios.post(this.route('api.catalog.product.characteristic.data'), {id: id}).then(result => {
                this.selectedCategories = result.data.selected;
                this.selectedItem = id;
                this.isSelectCategory = true
            });
        },
        deleteCharacteristics() {
            new swal({
                title: 'Ви впевнені?',
                text: 'Обрані характеристики будуть видалені',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    this.selectedCharacteristics = []
                    return
                }

                axios.post(this.route('api.catalog.product.characteristic.library.delete'), {data: this.selectedCharacteristics})
                    .then((result) => {
                        this.getData()
                        this.selectedCharacteristics = []
                        this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Характеристики успішно видалено', life: 3000 });
                    }).catch((error) => {
                        this.selectedCharacteristics = []
                        console.log(error);
                        window.scroll(0, 0);
                    })

            });
        },
        onPage(event) {
            this.filterParams.page = event.page+1
            this.filterParams.perPage = event.rows
            this.getData()
        },
        onSelectAllChange() {
            if (this.data.length >= this.filterParams.perPage) {
                if (!this.selectAll) {
                    this.selectAll = true;
                    this.selectedCharacteristics = this.data
                } else {
                    this.selectAll = false;
                    this.selectedCharacteristics = [];
                }
            }
        },
        onRowSelect() {
            if (this.data.length >= this.filterParams.perPage) {
                this.selectAll = this.selectedCharacteristics.length === this.data.length
            }
        },
        onRowUnselect() {
            if (this.data.length >= this.filterParams.perPage) {
                this.selectAll = false;
            }
        }
    }
};
</script>

<style scoped>
.bottom_btns {
    display: flex;
    gap: 16px;
    padding-top: 50px;
}
.add_file_btn {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #356EEF;
    display: flex;
    width: 237px;
    height: 40px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    text-decoration: none!important;
}
.add_file_btn.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}
.add_file_btn.main {
    background-color: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: #000000;
    box-shadow: 0px 1px 2px 0px #0000004D;
}
.confirm_buttons {
    display: flex;
    gap: 20px;
}
.confirm_button_cancel {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #356EEF;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}
.confirm_button_confirm {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.30);
}
.price_input {
    height: 40px!important;
    width: 100%;
    align-items: center;
    display: flex;
}
.check-text input {
  display: none;
}
.check-text svg {
  cursor: pointer;
}
.modal_main_content_container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.p-inputtext {
    height: auto;
}
.p-dropdown-label .p-inputtext{
    align-items: center;
    display: flex;
}
.selected_cats {
    margin-bottom: 20px;
}
.selected_cats p {
    margin: 0px;
}
</style>
